module.exports = __webpack_public_path__ + "img/sketch_01.8fd2b91c.png";